import { connect } from 'react-redux';
import PriceEstimation from './PriceEstimation';
import { priceEstimationDataSelector } from 'store/state/selectors/insights/prices';


export default connect(priceEstimationDataSelector)(PriceEstimation);
